import React from "react";
import jsPDF from "jspdf";
import dayjs from "dayjs";

export default function DownloadButton({ result, form }) {
  function handleDownload() {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Egyedi Hopp Homes mobilház árkalkuláció", 10, 20);
    doc.setFontSize(10);
    doc.text(`Dátum: ${dayjs().format("YYYY.MM.DD")}`, 10, 30);
    doc.text(`Alapterület: ${form.area} m²`, 10, 40);
    doc.text(`Tető: ${form.roof === "gable" ? "Nyeregtető" : "Lapostető"}`, 10, 45);
    doc.text(`Építési engedély: ${form.permit === "yes" ? "Van" : "Nincs"}`, 10, 50);
    doc.text(`Szállítási távolság: ${form.distance} km`, 10, 55);
    doc.text(`Tervezési mód: ${form.design === "yes" ? "Engedélyes" : "Nem engedélyes"}`, 10, 60);
    let y = 70;
    doc.text("Extrák:", 10, y);
    y += 5;
    const extrakNevek = {
      bathroom: "Fürdőszoba",
      kitchen: "Konyha",
      floorHeating: "Padlófűtés",
      blinds: "Redőny és szúnyogháló",
      crane: "Daruzás"
    };
    Object.entries(form.extras).forEach(([key, val]) => {
      if (val) doc.text(`- ${extrakNevek[key] || key}`, 15, y += 5);
    });
    y += 5;
    doc.text(`Nettó ár: ${result.netto.toLocaleString()} Ft`, 10, y += 5);
    doc.text(`ÁFA: ${result.afa.toLocaleString()} Ft`, 10, y += 5);
    doc.text(`Bruttó ár: ${result.brutto.toLocaleString()} Ft`, 10, y += 5);
    y += 10;
    doc.setFontSize(8);
    doc.text("Az árak tájékoztató jellegűek, végleges ajánlat személyes egyeztetés után.", 10, y);
    doc.save("hopp-homes-arajanlat.pdf");
  }

  return (
    <button onClick={handleDownload} className="bg-green-600 text-white px-4 py-2 rounded mt-4">PDF letöltése</button>
  );
}
